import {
    FETCH_ADDRESSES_REQUEST,
    FETCH_ADDRESSES_SUCCESS,
    FETCH_ADDRESSES_FAILURE,
    ADD_ADDRESS_SUCCESS,
    UPDATE_ADDRESS_SUCCESS,
    DELETE_ADDRESS_SUCCESS,
    GET_ADDRESS_REQUEST,
    GET_ADDRESS_SUCCESS,
    GET_ADDRESS_FAILURE,
} from "../actions/addressActions";



// const initialState = {
//   loading: false,
//   addresses: [],
//   error: null,
// };

const initialState = {
    addresses: [],
    addressList: [],
    loading: false,
    error: null,
    addAddressSuccess: false,
};
const addressReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_ADDRESSES_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };

        case FETCH_ADDRESSES_SUCCESS: {
            let list = action.payload;
            // if there's exactly one address, mark it default in state
            if (list.length === 1 && !list[0].is_default) {
                list = [{ ...list[0], is_default: true }];
            }
            return {
                ...state,
                loading: false,
                addresses: list,
            };
        }

        case FETCH_ADDRESSES_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        case ADD_ADDRESS_SUCCESS:
            return {
                ...state,
                addresses: [action.payload, ...state.addresses],
            };

        case UPDATE_ADDRESS_SUCCESS: {
            const updated = action.payload;
            return {
                ...state,
                addresses: state.addresses.map((addr) => {
                    const pk = addr.id ?? addr.address_id;
                    const updPk = updated.id ?? updated.address_id;
                    if (pk === updPk) {
                        return updated;
                    }
                    // if we just set one to default, unset all others  
                    if (updated.is_default) {
                        return { ...addr, is_default: false };
                    }
                    return addr;
                }),
            };
        }

        case DELETE_ADDRESS_SUCCESS: {
            const deletedId = action.payload;
            return {
                ...state,
                addresses: state.addresses.filter(addr => {
                    // handle either `id` or `address_id`
                    const pk = addr.id ?? addr.address_id;
                    return pk !== deletedId;
                }),
            };
        }

        // Get Address List
        case GET_ADDRESS_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };
        case GET_ADDRESS_SUCCESS:
            // console.log("Hrushi--====>", JSON.stringify(action.payload, null, 12));
            return {
                ...state,
                loading: false,
                addressList: action.payload,
            };
        case GET_ADDRESS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error,
            };

        default:
            return state;
    }
};

export default addressReducer;



// const addressReducer = (state = initialState, action) => {
//     switch (action.type) {
//         // Add Address
//         case ADD_ADDRESS_REQUEST:
//             return {
//                 ...state,
//                 loading: true,
//                 error: null,
//                 addAddressSuccess: false,
//             };
//         case ADD_ADDRESS_SUCCESS:
//             return {
//                 ...state,
//                 loading: false,
//                 addAddressSuccess: true,
//                 addressList: [...state.addressList, action.payload],
//             };
//         case ADD_ADDRESS_FAILURE:
//             return {
//                 ...state,
//                 loading: false,
//                 error: action.error,
//                 addAddressSuccess: false,
//             };

//         // Get Address List
//         case GET_ADDRESS_REQUEST:
//             return {
//                 ...state,
//                 loading: true,
//                 error: null,
//             };
//         case GET_ADDRESS_SUCCESS:
//             return {
//                 ...state,
//                 loading: false,
//                 addressList: action.payload,
//             };
//         case GET_ADDRESS_FAILURE:
//             return {
//                 ...state,
//                 loading: false,
//                 error: action.error,
//             };

//         default:
//             return state;
//     }
// };



// export default addressReducer;import {
//     ADD_ADDRESS_REQUEST,
//     ADD_ADDRESS_SUCCESS,
//     ADD_ADDRESS_FAILURE,
//     GET_ADDRESS_REQUEST,
//     GET_ADDRESS_SUCCESS,
//     GET_ADDRESS_FAILURE,
// } from "../actions/addressAction";